module.exports = __webpack_public_path__ + "media/images/lb/062-2949554d413e6b85247230d3f8ed7ddd.svg";